import { EMPTY_OBJECT } from '../../../../../constants/common'
import {
  filterPermittedActionsWithDividers,
  parseActionsOnValidDivider,
} from '../../../../../utils/massActions'
import {
  EMAIL_ACTION_ATTACH_REQUEST,
  EMAIL_ACTION_COPY_TO,
  EMAIL_ACTION_CREATE_SERVICE_REQUEST,
  EMAIL_ACTION_VIEW_ENTIRE_MESSAGE,
  EMAIL_PROFILE_ACTION_ADD_NOTE,
  EMAIL_PROFILE_ACTION_ARCHIVE,
  EMAIL_PROFILE_ACTION_DOWNLOAD_FILES,
  EMAIL_PROFILE_ACTION_FORWARD,
  EMAIL_PROFILE_ACTION_MESSAGE_RESEND,
  EMAIL_PROFILE_ACTION_PRINT,
  EMAIL_PROFILE_ACTION_REPLY,
  EMAIL_PROFILE_ACTION_REPLY_ALL,
} from '../../../../Email'
import { getSelectDropdownListDividerOption } from '../../../../Select'

export function getMessageDropdownActions({ data, t }) {
  const {
    files,
    has_raw_text: hasRawText,
    permissions = EMPTY_OBJECT,
  } = data || EMPTY_OBJECT

  const items = [
    {
      label: t('RequestProfile.TabEmailsResendActionKey'),
      permission: permissions.can_resend,
      value: EMAIL_PROFILE_ACTION_MESSAGE_RESEND,
    },
    {
      label: t('RequestProfile.TabEmailsReplyActionKey'),
      permission: permissions.can_reply,
      value: EMAIL_PROFILE_ACTION_REPLY,
    },
    {
      label: t('RequestProfile.TabEmailsReplyAllActionKey'),
      permission: permissions.can_reply,
      value: EMAIL_PROFILE_ACTION_REPLY_ALL,
    },
    {
      label: t('RequestProfile.TabEmailsForwardActionKey'),
      permission: permissions.can_reply,
      value: EMAIL_PROFILE_ACTION_FORWARD,
    },
    {
      label: t('RequestProfile.TabEmailsAddNoteActionKey'),
      permission: permissions.can_edit_note,
      value: EMAIL_PROFILE_ACTION_ADD_NOTE,
    },
    {
      label: t('RequestProfile.TabEmailsViewEntireMessageActionKey'),
      permission: hasRawText,
      value: EMAIL_ACTION_VIEW_ENTIRE_MESSAGE,
    },
    {
      label: t('RequestProfile.TabEmailsPrintActionKey'),
      permission: true,
      value: EMAIL_PROFILE_ACTION_PRINT,
    },
    {
      label: t('RequestProfile.TabEmailsDownloadAllFilesActionKey'),
      permission: files?.length > 0,
      value: EMAIL_PROFILE_ACTION_DOWNLOAD_FILES,
    },
    {
      label: t('RequestProfile.TabEmailsAddNewServiceRequestActionKey'),
      permission: permissions.can_create_request,
      value: EMAIL_ACTION_CREATE_SERVICE_REQUEST,
    },
    {
      label: t('RequestProfile.TabEmailsAttachToServiceRequestActionKey'),
      permission: permissions.can_attach_to_request,
      value: EMAIL_ACTION_ATTACH_REQUEST,
    },
    {
      label: t('RequestProfile.TabEmailsCopyToActionKey'),
      permission: permissions.can_copy_to_archive,
      value: EMAIL_ACTION_COPY_TO,
    },
    getSelectDropdownListDividerOption(),
    {
      label: t('RequestProfile.TabEmailsDeleteActionKey'),
      permission: permissions.can_archive,
      value: EMAIL_PROFILE_ACTION_ARCHIVE,
    },
  ]

  return parseActionsOnValidDivider(filterPermittedActionsWithDividers(items))
}
